<template>
  <div v-if="links && links.length" class="breadcrumbs">
    <ul class="breadcrumbs__list">
      <li v-for="(item, i) in links" :key="i" class="breadcrumbs__item">
        <icon name="arrow-drop-right" />
        <router-link
          class="breadcrumbs__link"
          :to="item.route"
          v-if="item.route"
        >
          {{ item | localeField("title") }}
        </router-link>
        <span v-else>{{ item | localeField("title") }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "BreadcrumbsComponent",
  props: {
    links: Array
  }
};
</script>

<style lang="scss" scoped>
.breadcrumbs {
  &__list {
    display: flex;
    align-items: center;
    margin: 0;
    padding: 0;
    overflow: auto;
    opacity: 0.5;
  }

  &__item {
    display: flex;
    align-items: center;
    margin-left: 5px;
    flex-shrink: 0;

    &:first-child {
      margin-left: 0;

      .svg-icon {
        display: none;
      }
    }

    .svg-icon {
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }
  }

  &__link {
    color: #262626;
    font-size: 0.75rem;
    line-height: 18px;
    text-decoration: none;
    transition: color var(--transition, 0.2s);

    &:hover {
      color: var(--main-dark, #005197);
    }
  }
}
</style>
